export const CAMPOS_BUSCA = {
  tipoImovel:'Tipo de imóvel',cidade:'Cidade',estado:'Estado (UF)',bairro:'Bairro',valorMin:'Valor mínimo',valorMax:'Valor máximo',
  descontoMin:'Desconto mínimo (%)',origemSite:'Origem',leiloeiro:'Leiloeiro',comitente:'Comitente',modalidade:'Modalidade',
  dataInicio:'Data inicial do leilão',dataFim:'Data final do leilão',dataInicioCaptura:'Capturado desde',dataFimCaptura:'Capturado até',
  somenteCaixa:'Somente imóveis da Caixa (1)',aceitaFinanciamento:'Aceita financiamento (1)',aceitaFinanciamentoCaixa:'Financiamento Caixa (1)',aceitaFgts:'Aceita FGTS (1)',
  disponibilidadeData:'Data (com_data, sem_data ou todos)',ocultarNaoInteressa:'Ocultar não interessantes (1)',etapaAnalise:'Etapa da análise',excluirParteIdeal:'Excluir parte ideal (1)',excluirSustado:'Excluir sustados (1)',situacao:'Situação',ordenarPor:'Ordenação',endereco:'Endereço',titulo:'Título'
};
const TIPOS = { apartamento:'Apartamento',studio:'Studio',flat:'Flat',casa:'Casa',terreno:'Terreno / Lote','galpão':'Galpão',comercial:'Comercial','área rural':'Área Rural','área industrial':'Galpão' };
export function queryDaBusca(filtros={}) {
  const p=new URLSearchParams();
  for(const [k,v] of Object.entries(filtros)){
    if(!(k in CAMPOS_BUSCA)||v===null||v===undefined||v==='')continue;
    const lista=Array.isArray(v)?v:[v];
    for(const x of lista){
      if(x===false||x==='false')continue;
      p.append(k,k==='tipoImovel'?(TIPOS[String(x).toLowerCase()]||String(x)):(x===true?'1':String(x)));
    }
  }
  return p.toString();
}
export function resumoBusca(filtros={}) {
 return Object.entries(filtros).filter(([k])=>k in CAMPOS_BUSCA).map(([k,v])=>`${CAMPOS_BUSCA[k]}: ${Array.isArray(v)?v.join(', '):v}`).join(' · ');
}
